import { FC, memo, type RefObject, useMemo } from 'react'
import styled from 'styled-components'
import { mq, designGrid, vw, getP24 } from '@/styles'
import { useTranslator } from '@/hooks'
import { TypeCmsProjectCard } from '@/schema'
import { CardProject } from './CardProject'

type Props = {
  data: TypeCmsProjectCard[]
  ref?: RefObject<HTMLElement>
}


const getRelated = (projects) => projects.map((project, idx) => {
  return (<CardProject key={idx+project.name} data={project} isRelated={true}/>)
})

const headingId = 'relateds'
export const SectionRelatedProject:FC<Props> = memo(({ data, ref }) => {
  const { t } = useTranslator()
  const Related = useMemo(() => getRelated(data.slice(0, 2)), [data])

  return (
    <Section ref={ref} aria-labelledby={headingId}>
      <h2 id={headingId}>{t('project.content_page.related_projects')}</h2>
      <div>
        {Related}
      </div>
    </Section>
  )
})


const Section = styled.section`
  ${designGrid({})}
  margin: 0;
  padding: 90px 0 100px;

  ${mq.greaterThan('tablet')}{
    margin: 0;
    padding: 110px 0 100px;
  }

  h2 {
    ${getP24()}
    text-align: left;
    grid-area: 1 / 1 / span 1 / span 6;
    margin-bottom: ${vw(30, 'mobile')};

    ${mq.greaterThan('tablet')} {
      grid-area: 1 / 1 / span 1 / span 3;
      margin-bottom: ${vw(40, 'desktop')};
    }
  }

  > div {
    display: grid;
    grid-area: 2 / 1 / span 1 / span 6;
    grid-column-gap: ${vw(23, 'mobile')};
    grid-row-gap: ${vw(20, 'mobile')};
    grid-template-columns: 1fr 1fr;

    ${mq.greaterThan('tablet')} {
      grid-area: 2 / 1 / span 1 / span 12;
      grid-column-gap: ${vw(23, 'desktop')};
      grid-row-gap: 0;
      grid-template-columns: repeat(2, 1fr);
    }
  }
`
